import ArchiveGroupModal from 'components/common/group/content/ArchiveGroupModal';
import RemoveGroupModal from 'components/common/group/content/RemoveGroupModal';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useBiDashboardPageStore } from 'store/pages/tools/bi-groups-dashboard/pageStore';
import MoveGroupModal from './MoveGroupModal';

const RowActionModals: React.FC = observer(() => {
  const {
    groupInteractionDelegate: { selectedGroup, removeModal, archiveModal, archiveGroup, removeGroup },
  } = useBiDashboardPageStore();
  return (
    <>
      <RemoveGroupModal
        show={removeModal.isVisible}
        onClose={removeModal.close}
        onAction={removeGroup}
        groupName={selectedGroup.name}
      />
      <ArchiveGroupModal
        show={archiveModal.isVisible}
        onClose={archiveModal.close}
        onAction={archiveGroup}
        groupName={selectedGroup.name}
      />
      <MoveGroupModal />
    </>
  );
});

export default RowActionModals;
